import { ThemeProvider } from "@mui/material/styles";
import { BrowserRouter } from "react-router-dom";

import { ErrorBoundary } from "./components/common/errorBoundary";
import SettingsPage from "./components/views/settingsPage";
import { BASE_PATH } from "@octopus-settings/constants/config/router";

import { settingsTheme } from "./theme";

const App = () => {
  return (
    <ThemeProvider theme={settingsTheme}>
      <BrowserRouter basename={BASE_PATH}>
        <ErrorBoundary>
          <SettingsPage />
        </ErrorBoundary>
      </BrowserRouter>
    </ThemeProvider>
  );
};

export default App;
